// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + "shimport" + ".legacy." + "90dfed19ae8cee6ec2ad" + ".js";
};